import { useNavigate } from "react-router-dom";
import { useNavMenuOptions } from "./api/getNavMenuOptions";
import { getAliasProps } from "../../ui/blocks/Navbar";
import { CircularProgress } from "@mui/material";
import {
  setBreadCrumbsElement,
  setCurrentTool,
} from "../../shared/store/menu/menu";

import { useDispatch } from "react-redux";

export default function LandingPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useNavMenuOptions({
    config: {
      onSuccess: (data) => {
        const index = data?.findIndex(
          (alias) =>
            alias?.ferramenta !== "TITULO" && alias?.ferramenta !== "LINK"
        );
        const firstValidMenuItem = data[index];
        const { isDirectChannel, parsedFilters, route } =
          getAliasProps(firstValidMenuItem);
        sessionStorage.setItem("cvMenuItem", index);
        try {
          dispatch(
            setCurrentTool(
              firstValidMenuItem.titulo,
              firstValidMenuItem.ferramenta
            )
          );
          dispatch(setBreadCrumbsElement(route, 0, isDirectChannel));
        } catch (e) {
          console.error(e);
        }
        if (route !== undefined) {
          navigate(route, {
            state: { parsedFilters: parsedFilters },
          });
        } else {
          navigate("/dashboard");
        }
      },
    },
  });

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-100">
      <CircularProgress />
    </div>
  );
}
